import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, ElementRef, Input, OnChanges, OnInit, TemplateRef, ViewChild, inject, signal } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

import { MatTableDataSource } from '@angular/material/table';
import { EntryData, SimilarStructure, Structure} from '../entry/structure-data.models';
import { MatPaginator } from '@angular/material/paginator';
import { ConfigService } from '../config.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../common.service';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { EntryStatusComponent } from '../entry-status/entry-status.component';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { DomSanitizer } from "@angular/platform-browser";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { HttpResponse } from '@angular/common/http';
import { PALETTE } from '../molstar-alpha-missense';
import { CheckboxService } from './checkbox.service';
import { Subscription, combineLatest, filter, map, take } from 'rxjs';
import * as XLSX from 'xlsx';
import { DownloadService } from '../download-service';
import { PlatformService } from '../platform.service';
import { MolstarPluginService } from '../molstar-plugin-service';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EntrySelectors } from '../state/entry.selectors';
import { UtilService } from '../util.service';
import { FoldseekService } from './foldseek.service';
import { FoldseekapiService } from './foldseekapi.service';
import { NtdxTabComponent } from './ntdx-tab/ntdx-tab.component';
import { BfvdTabComponent } from './bfvd-tab/bfvd-tab.component';
import { ViroTabComponent } from './viro-tab/viro-tab.component';
import { VadTabComponent } from './vad-tab/vad-tab.component';
import { AllbacteriaTabComponent } from './allbacteria-tab/allbacteria-tab.component';
declare var PDBeMolstarPlugin: any;

@Component({
    selector: 'app-foldseek-table',
    templateUrl: './foldseek-table.component.html',
    styleUrls: ['./foldseek-table.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class FoldseekTableComponent implements OnInit, AfterViewInit, OnChanges{
  @Input() accession: string;
  @Input() afdb_accession: string;
  
  
  checked = false;
  disabled = false;
  superposeData = [];

  subTimeout:any;
  isColorby: boolean= true;
  // apiData = {};
  targetColors = {};
  checkboxState: { [key: string]: boolean } = {};
  disabledState: { [key: string]: boolean } = {};
  private subscription: Subscription;

  structure: Structure;
  pdbeMolstar: any;
  molLoadComplete:boolean = false;
  viewerInstance: any = undefined;
  apiData2 = [];
  
  public isOldUniprotEntry: boolean = false;

  public entryData = signal<EntryData>({} as EntryData);
  public uniprotData = signal<any>({});
  
  private readonly destroyRef = inject(DestroyRef);
  
  constructor(
    private sanitizer:DomSanitizer,
    private route: ActivatedRoute,
    private commonService: CommonService,
    public gaService: GoogleAnalyticsService,
    private configService: ConfigService,
    private changeDetectorRef: ChangeDetectorRef,
    private checkboxService: CheckboxService,
    private el: ElementRef,
    private utilService: UtilService,
    private store: Store,
    private molstarPluginService : MolstarPluginService,
    private platform: PlatformService) { }

  private assignedColor: {[targetId: string]: string} = {};
  private nextColorIndex = 0;

  isDownloadFailed = false;
  isDownloadDone = false;
  isDownloadRunning = false;
  readonly MAX_SELECTION = 100;
  isLimitReachedAFDB = false;
  isLimitReachedPDB = false;

  isDisabled = false;

  downloadService = inject(DownloadService);
  public foldseekService = inject(FoldseekService);
  public foldseekapiService = inject(FoldseekapiService);

  records="10";
  start="0";
  startPDB = "0";
  startAFDB = "0";

  errorPDB: string;
  errorAFDB: string;

  recordsPDB = "10";
  recordsAFDB = "10";

  currentPDBPage = 0;
  currentAFDBPage = 0;

  sort_direction_PDB='asc'; 
  sort_column_PDB='evalue'; 

  sort_direction_AFDB='asc'; 
  sort_column_AFDB='evalue';

  species_name_filter_PDB="";
  species_name_filter_AFDB="";

  filteritemPDB = "";
  filteritemAFDB = "";


  @ViewChild('paginator3',{ static: true }) paginator3!: MatPaginator;
  @ViewChild('paginator4',{ static: true }) paginator4!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild(AllbacteriaTabComponent) atbcTab!: AllbacteriaTabComponent;
  @ViewChild(BfvdTabComponent) bfvdTab!: BfvdTabComponent;
  @ViewChild(NtdxTabComponent) ntdxTab!: NtdxTabComponent;
  @ViewChild(ViroTabComponent) viroTab!: ViroTabComponent;
  @ViewChild(VadTabComponent) vadTab!: VadTabComponent;


  @ViewChild('tabGroup') tabGroup: MatTabGroup;
 
  ngOnChanges(): void {
    this.foldseekapiService.accession.set(this.accession);
    this.foldseekapiService.afdb_accession.set(this.afdb_accession);
  }
  
  ngOnInit(): void {
  
    this.downloadService.updateSelectedValueAFDB([]);
    this.downloadService.updateSelectedValuePDB([]);
    this.subscription = this.checkboxService.checkboxState$.subscribe(state => {
      this.checkboxState = state;
      this.changeDetectorRef.detectChanges(); // Trigger change detection manually
    });

    this.checkboxService.disabledState$.subscribe(state => {
      this.disabledState = state;
    });

    combineLatest([
      this.store.select(EntrySelectors.entryData).pipe(),
      this.store.select(EntrySelectors.uniprotData).pipe(),
    ])
    .pipe(
      filter(([entryData, uniprotData]) =>
          !!entryData &&
          !!entryData.modelEntityId  // prove entry is loaded
        ),
      take(1),
      takeUntilDestroyed(this.destroyRef)
    )
    .subscribe(([entryData, uniprotData]) => {
      this.entryData.set(entryData)
      this.uniprotData.set(uniprotData)
      // if (this.entryData().isUniProt && this.entryData().providerId === "GDM") {
      //   if((this.entryData().sequenceVersionDate!= "" || this.entryData().sequenceVersionDate!= null) && (this.uniprotData()?.sequence?.modified != "" || this.uniprotData()?.sequence?.modified != null)){
      //     this.isOldUniprotEntry = this.utilService.areDatesDifferent(this.entryData().sequenceVersionDate, this.uniprotData()?.sequence?.modified);
      //   }
      // }
    });
    this.initViewer();
    this.foldseekapiService.checkAndGetStructureData(this.recordsPDB, this.startPDB, this.sort_direction_PDB, this.sort_column_PDB, this.species_name_filter_PDB);
    this.foldseekapiService.checkAndGetAFDBData(this.recordsAFDB, this.startAFDB, this.sort_direction_AFDB, this.sort_column_AFDB, this.species_name_filter_AFDB);
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
    this.atbcTab.checkAndGetATBCData("10", "0", "asc", "evalue", "");
    this.bfvdTab.checkAndGetBFVDData("10", "0", "asc", "evalue", "");
    this.ntdxTab.checkAndGetNTDXData("10", "0", "asc", "evalue", "");
    this.viroTab.checkAndGetVIROData("10", "0", "asc", "evalue", "");
    this.vadTab.checkAndGetVADData("10", "0", "asc", "evalue", "");
  }

  exportSuperpose(){
    PDBeMolstarPlugin.extensions.Foldseek.exportModels(this.viewerInstance);
    this.gaService.eventEmitter('foldseek_download', 'FS_similar_structures', 'click', 'foldseek_download_structures', 'Clicks on the "Download aligned coordinates (mmCIF)" button on the Foldseek similar structure table');
  }

  switchtoTab(flag) {
    if (this.tabGroup && flag === "afdb" ) {
      this.tabGroup.selectedIndex = 1; 
    } 
    if (this.tabGroup && flag === "pdb" ) {
      this.tabGroup.selectedIndex = 0; 
    }
  }
  
  async initViewer(){
    this.structure = {
      model_url: this.entryData().bcifUrl,
      model_format: 'cif',
      binary: true,
    };
    // this.viewerInstance = new PDBeMolstarPlugin();
    await this.molstarPluginService.loadPlugin();
    const pluginInstance = this.molstarPluginService.createInstance();
    this.viewerInstance = pluginInstance;

    const platformdocument = this.platform.getDocument();
    const viewerContainer = platformdocument.getElementById('superpose-viewer');
    if (!viewerContainer) return;
    
    const options = {
      customData: {
          url: this.structure.model_url, 
          format: 'cif', 
          binary: true,
      },
      bgColor: { r: 255, g: 255, b: 255 },
      alphafoldView: true,
      sequencePanel: false,
      hideControls: true,
      hideCanvasControls: ['selection', 'animation', 'controlToggle', 'controlInfo', 'trajectory' ],
      visualStyle: {
          polymer: { type: 'putty', size: 'uniform' },
          het: 'ball-and-stick',
          nonStandard: 'ball-and-stick',
          carbs: 'carbohydrate',
      },
      hideStructure: ['water'],
      // expanded: true,
    };
    this.changeDetectorRef.detectChanges(); 
    // Call render method to display the 3D view
    this.viewerInstance.render(viewerContainer, options);
  }
 
  private getColor(targetId: string): string{
    if (this.assignedColor[targetId]) return this.assignedColor[targetId];
    const color = PALETTE[this.nextColorIndex];
    this.nextColorIndex = (this.nextColorIndex+1) % PALETTE.length;
    this.assignedColor[targetId] = color;
    return color;
  }

  async loadTarget(id) {
    try{
      this.checkboxService.setCheckboxDisabledState(id, true);
      this.changeDetectorRef.detectChanges();
      const result = await PDBeMolstarPlugin.extensions.Foldseek.loadFoldseekSuperposition(this.viewerInstance, id, this.foldseekapiService.apiData()[id], this.getColor(id));
      return result;
    } 
    finally{
      this.checkboxService.setCheckboxDisabledState(id, false);
      this.changeDetectorRef.detectChanges();
    }
    
  }
  
  setsuperpose_color(){
    if(this.isColorby){
      this.viewerInstance.visual.clearSelection('main');
    }else{
      this.viewerInstance.visual.select({ data: [{ color: '#A9ABAA' }], structureId: 'main' });
    }
  }
  toggleSupeposeVisibility(event, entry: any) {
    entry.isShow = !entry.isShow;
    const structId = entry.accession;
    if (!entry.isShow) {
        this.viewerInstance.visual.structureVisibility(structId, false);
        this.gaService.eventEmitter('foldseek_align', 'FS_similar_structures', 'click', 'foldseek_align_hide', 'Click on the eye icon for aligned structure');
    } else {
        this.viewerInstance.visual.structureVisibility(structId, true);
        this.gaService.eventEmitter('foldseek_align', 'FS_similar_structures', 'click', 'foldseek_align_pLDDT', 'Click on checkbox for pLDDT colouring');
    }
  }
  removeSuperpose(item) {
    const accession = item.accession;
    this.superposeData = this.superposeData.filter(entry => entry.accession !== accession);
    this.checkboxService.setCheckboxDisabledState(accession, true);
    this.viewerInstance.deleteStructure(item.accession).then(() => {
      this.checkboxService.setCheckboxDisabledState(accession, false);
    });

    this.checkboxService.setCheckboxState(accession, false);
    const platformdocument = this.platform.getDocument();
    const checkbox = platformdocument.getElementById(`${accession}`) as HTMLInputElement; 
    if (checkbox) {
      checkbox.checked = false;
    }
  }
  trackBySuperposedItem(index: number, item: any): any {
    return item.id || index; 
  }

  superposeSliderToggleAFDB(e){
    this.superposeSliderToggle(e.event, e.accession)
  }
  async superposeSliderToggle(e, accession){
    const checked = e.target.checked;
    const id = accession;
    let rmsdData;
    if (checked) {
      this.checkboxService.setCheckboxState(id, checked);
      await this.loadTarget(id).then((result) => {
        rmsdData = result;
      });
      const numrmsd = parseFloat(rmsdData.rmsd).toFixed(2); // Convert to a number
     
      this.superposeData.push({accession: id, targetToShow: this.foldseekapiService.apiData()[id].targetToShow, refLinkId: this.foldseekapiService.apiData()[id].refLinkId, rmsd:`RMSD ${numrmsd}`,  desc:this.foldseekapiService.apiData()[id].desc, color:this.getColor(id), isShow: true});
      this.changeDetectorRef.detectChanges();
    
      this.gaService.eventEmitter('foldseek_align', 'FS_similar_structures', 'click', 'foldseek_align_3D', 'Click on the align 3D structures');
    } else {
      this.checkboxService.setCheckboxDisabledState(id, true);
      await this.viewerInstance.deleteStructure(id).then(() => {
        this.checkboxService.setCheckboxDisabledState(id, false);
        this.changeDetectorRef.detectChanges();
      });

      this.checkboxService.setCheckboxState(id, checked);
      this.superposeData = this.superposeData.filter(entry => entry.accession !== id);

      this.changeDetectorRef.detectChanges();
    }
  }

  removeAllSuperposition() {
    for (const entry of this.superposeData) {
      this.checkboxService.setCheckboxState(entry.accession, false);
      this.viewerInstance.deleteStructure(entry.accession).then(() => {});
    }
    this.superposeData = [];
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
 

  startStructureSearch(){
    const auth = this.configService.getConfig().apiKey ? `&key=${this.configService.getConfig().apiKey}` : "";
    const configUrl = this.configService.getConfig().structureSearchApiUrl ? this.configService.getConfig().structureSearchApiUrl : "https://test.alphafold.ebi.ac.uk/api/structure/search/";


    // const apiUrl = `${configUrl}${this.accession}`;
    const apiUrl = `${configUrl}${this.accession}?latest_version=${this.entryData().latestVersion}${auth}`;

    this.commonService.postApiData(apiUrl, {}).subscribe(async (response) => {
      this.changeDetectorRef.detectChanges();
      if(response && (response.status == 202)){
        // this.isStructureRunning = true;
        // this.isStructureCach = true; 
        this.foldseekService.updateStructureRunning(true);
        this.foldseekService.updateIsStructureCach(true);
        this.changeDetectorRef.detectChanges();
        this.foldseekapiService.checkAndGetStructureData(this.recordsPDB, this.startPDB, this.sort_direction_PDB, this.sort_column_PDB, this.species_name_filter_PDB);
        this.foldseekapiService.checkAndGetAFDBData(this.recordsAFDB, this.startAFDB, this.sort_direction_AFDB, this.sort_column_AFDB, this.species_name_filter_AFDB);
        this.gaService.eventEmitter(
          'foldseek_search', 'FS_similar_structures', 'click', 'foldseek_find_trigger', 'Clicks on the button "Find Similar structures" to trigger search'
        );
      }
      if(response && (response.status == 200 || response.body?.message.startsWith("There are results for accession"))){
        // this.isStructureRunning = false;
        // this.isStructureCach = true; 
        // this.isPDBFoldseekCach = true;
        // this.isAFDBFoldseekCach = true;

        this.foldseekService.updateStructureRunning(false);
        this.foldseekService.updateIsStructureCach(true);
        this.foldseekService.updateIsPDBFoldseekCach(true);
        this.foldseekService.updateIsAFDBFoldseekCach(true);

        this.changeDetectorRef.detectChanges();
        this.foldseekapiService.checkAndGetStructureData(this.recordsPDB, this.startPDB, this.sort_direction_PDB, this.sort_column_PDB, this.species_name_filter_PDB);
        this.foldseekapiService.checkAndGetAFDBData(this.recordsAFDB, this.startAFDB, this.sort_direction_AFDB, this.sort_column_AFDB, this.species_name_filter_AFDB);
        this.gaService.eventEmitter(
          'foldseek_search', 'FS_similar_structures', 'click', 'foldseek_find_trigger', 'Clicks on the button "Find Similar structures" to trigger search'
        );
      }
    },
    (error) => {
      const code =  error.status;
      if(code === 404){
        // this.isStructureCach = false;
        // this.isStructureRunning = false;
        this.foldseekService.updateStructureRunning(false);
        this.foldseekService.updateIsStructureCach(false);
      }
     
      if(code === 422 || code === 302 || code === 500){
        // this.isStructureFail = true;
        this.foldseekService.updateIsStructureFail(true);
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    const tabLable = tabChangeEvent.tab.textLabel;

    if(tabChangeEvent.index === 0){
      this.gaService.eventEmitter(
        'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_PDB_structures', 'Click on the tab to see PDB structures'
      );
    }
    if(tabChangeEvent.index === 1){
      this.gaService.eventEmitter(
        'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_AFDB_structures', 'Click on the tab to see AFDB50 structures'
      );
    }
    if(tabChangeEvent.index === 2){
      this.atbcTab.checkAndGetATBCData("10", "0", "asc", "evalue", "");
      this.gaService.eventEmitter(
        'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_ATBC_structures', 'Click on the tab to see ATBC structures'
      );
    }
    if(tabChangeEvent.index === 3){
      this.bfvdTab.checkAndGetBFVDData("10", "0", "asc", "evalue", "");
      this.gaService.eventEmitter(
        'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_BFVD_structures', 'Click on the tab to see BFVD structures'
      );
    }
    if(tabChangeEvent.index === 4){
      this.ntdxTab.checkAndGetNTDXData("10", "0", "asc", "evalue", "");
      this.gaService.eventEmitter(
        'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_NTDX_structures', 'Click on the tab to see NTDX structures'
      );
    }
    if(tabChangeEvent.index === 5){
      this.viroTab.checkAndGetVIROData("10", "0", "asc", "evalue", "");
      this.gaService.eventEmitter(
        'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_NTDX_structures', 'Click on the tab to see NTDX structures'
      );
    }
    if(tabChangeEvent.index === 6){
      this.vadTab.checkAndGetVADData("10", "0", "asc", "evalue", "");
      this.gaService.eventEmitter(
        'foldseek_results', 'FS_similar_structures', 'click', 'foldseek_VAD_structures', 'Click on the tab to see VAD structures'
      );
    }

  }

}
